import React from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import { motion } from "framer-motion"; // Animation library
import nexus from "./assets/nexus.png";
import img1 from "./assets/1.png"; // Изображение с Clash of Clans
import img2 from "./assets/2.png"; // Каталог с играми
import img3 from "./assets/3.png"; // Карточки с Brawl Pass
import img4 from "./assets/4.png"; // Профиль пользователя
import img5 from "./assets/5.png"; // Баланс и пополнение
import img6 from "./assets/6.png"; // Подключение почты
import Policy from "./Policy"; // New Offer page component
import "./App.css";

function Home() {
	const telegramBotLink = "https://t.me/NarekNexus_bot";

	const content = [
		{
			image: img1,
			title: "Clash of Clans",
			text: "Добро пожаловать в мир уникальных товаров с Nexus! Здесь вы найдете эксклюзивные предложения для ваших любимых игр, включая Clash of Clans.",
		},
		{
			image: img2,
			title: "Каталог игр",
			text: "Исследуйте наш богатый каталог игр, таких как Clash Royale, Brawl Stars, и Boom Beach. Все товары — в одном месте!",
		},
		{
			image: img3,
			title: "Ваши любимые товары",
			text: "Brawl Pass, редкие ресурсы и уникальные предметы для игр — всё это доступно в Nexus по лучшим ценам.",
		},
		{
			image: img4,
			title: "Ваш профиль",
			text: "Проверяйте баланс, редактируйте личные данные и отслеживайте историю покупок прямо в вашем профиле.",
		},
		{
			image: img5,
			title: "Пополнение баланса",
			text: "Легко пополняйте баланс в рублях. Выберите одну из предложенных сумм или введите свою. Nexus делает это удобно!",
		},
		{
			image: img6,
			title: "Подключение Supercell ID",
			text: "Подключите вашу почту к Supercell ID и наслаждайтесь еще большими возможностями в ваших любимых играх!",
		},
	];

	return (
		<div className="App">
			{/* Header */}
			<header className="header">
				<motion.img
					src={nexus}
					className="App-logo"
					alt="Логотип Nexus"
					initial={{ opacity: 0, y: -20 }}
					animate={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8 }}
				/>
				<motion.h1
					className="title"
					initial={{ opacity: 0, x: -50 }}
					animate={{ opacity: 1, x: 0 }}
					transition={{ duration: 1 }}
				>
					<Link to="/" className="title-link">
						Nexus Shop
					</Link>
				</motion.h1>
				<div className="header-links">
					<motion.div
						initial={{ scale: 0.8 }}
						animate={{ scale: 1 }}
						transition={{ duration: 0.1, ease: "easeOut" }}
					>
						<Link to="/policy" className="oferta-link">
							Оферта
						</Link>
					</motion.div>
					<motion.a
						href={telegramBotLink}
						className="telegram-link"
						rel="noopener noreferrer" // Added for security with external links
						initial={{ scale: 0.8 }}
						animate={{ scale: 1 }}
						transition={{ duration: 0.1, ease: "easeOut" }}
					>
						Перейти в Telegram-бот
					</motion.a>
				</div>
			</header>

			{/* Main Content */}
			<div className="main">
				<div className="grid-container">
					{content.map((item, index) => (
						<motion.div
							className="grid-item"
							key={index}
							initial={{ opacity: 0, scale: 0.9 }}
							whileInView={{ opacity: 1, scale: 1 }}
							viewport={{ once: true, amount: 0.3 }}
							transition={{ duration: 0.5, delay: index * 0.2 }}
						>
							<h2 className="grid-title">{item.title}</h2>
							<img
								src={item.image}
								alt={`Контент ${index + 1}`}
								className="grid-image"
							/>
							<p className="grid-text">{item.text}</p>
						</motion.div>
					))}
				</div>
			</div>

			{/* Footer */}
			<motion.footer
				className="footer"
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ duration: 1, delay: 1 }}
			>
				<p>© 2024 Nexus Shop. Все права защищены.</p>
				<p>
					ИП Марянян Нарек Артурович
					<br />
					ОГРНИП: 123456789012345
					<br />
					ИНН: 9876543210
					<br />
					Почта: narmargold@gmail.com
				</p>
				<p>
					Внимание: Платные услуги включают персонализированные предложения,
					эксклюзивные скидки, ускоренную доставку и консультации. Подробнее — в
					нашем Telegram-боте.
				</p>
			</motion.footer>
		</div>
	);
}

function App() {
	return (
		<Router>
			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/policy" element={<Policy />} />
			</Routes>
		</Router>
	);
}

export default App;
